/* eslint-disable */
// The moving traffic of "המתחם בתנועה": cars on the traced streets, pedestrians on the traced paths and the light rail.
// Coordinates are in pixels of the aerial image (1858 x 826). createSim(ctx, getNight) returns { step(dt), draw() }.
export function createSim(ctx, getNight) {
  var night = 0;
  function S(p){return[(p[0]-215)/0.775,(p[1]-26)/0.775];}
  function conv(a){return a.map(S);}
  var ROADS={
   A:[[455,28],[470,100],[483,158],[520,260],[560,370],[600,470],[612,490],[640,580],[658,675]],
   B:[[483,158],[600,145],[800,118],[1013,90]],
   C:[[1013,90],[1012,200],[1010,300],[1015,400],[1017,488]],
   Dw:[[1017,488],[800,488],[610,488]],
   De:[[1017,488],[1200,488],[1400,484]],
   E:[[1013,90],[1250,91],[1515,92]]
  };
  var WALK=[
   [[640,247],[700,240],[765,238],[768,260],[765,300],[765,325]],
   [[580,388],[620,378],[660,368],[690,365]],
   [[838,325],[832,355],[835,385],[860,392],[880,378],[862,362],[885,345],[895,335],[878,328],[862,332]],
   [[1250,470],[1236,435],[1240,410],[1258,415],[1262,445],[1260,470],[1288,445],[1300,420],[1288,385],[1285,360],[1300,400],[1308,440],[1315,465],[1345,455],[1350,432],[1342,405],[1358,385],[1378,380]]
  ];
  var RAIL=[[1478,22],[1500,60],[1520,110],[1530,140],[1535,200],[1550,270],[1560,340],[1565,420],[1562,470],[1558,510],[1557,560],[1557,610],[1555,640],[1553,672]];
  // ---- path helpers: smooth (Catmull-Rom), resample, offset sideways ----
  function smooth(pts,n){
   var out=[];
   for(var i=0;i<pts.length-1;i++){
    var p0=pts[Math.max(0,i-1)],p1=pts[i],p2=pts[i+1],p3=pts[Math.min(pts.length-1,i+2)];
    for(var t=0;t<n;t++){var u=t/n,u2=u*u,u3=u2*u;
     out.push([0.5*((2*p1[0])+(-p0[0]+p2[0])*u+(2*p0[0]-5*p1[0]+4*p2[0]-p3[0])*u2+(-p0[0]+3*p1[0]-3*p2[0]+p3[0])*u3),
               0.5*((2*p1[1])+(-p0[1]+p2[1])*u+(2*p0[1]-5*p1[1]+4*p2[1]-p3[1])*u2+(-p0[1]+3*p1[1]-3*p2[1]+p3[1])*u3)]);}
   }
   out.push(pts[pts.length-1]);return out;
  }
  function build(pts,off){
   var s=smooth(pts,10),q=[];
   for(var i=0;i<s.length;i++){
    var a=s[Math.max(0,i-1)],b=s[Math.min(s.length-1,i+1)],dx=b[0]-a[0],dy=b[1]-a[1],l=Math.hypot(dx,dy)||1;
    q.push([s[i][0]-dy/l*off,s[i][1]+dx/l*off]);}
   var cum=[0];for(var j=1;j<q.length;j++)cum.push(cum[j-1]+Math.hypot(q[j][0]-q[j-1][0],q[j][1]-q[j-1][1]));
   return{p:q,c:cum,len:cum[cum.length-1]};
  }
  function at(path,s){
   s=Math.max(0,Math.min(path.len-0.01,s));var lo=0,hi=path.c.length-1;
   while(hi-lo>1){var m=(lo+hi)>>1;if(path.c[m]<=s)lo=m;else hi=m;}
   var a=path.p[lo],b=path.p[hi],t=(s-path.c[lo])/((path.c[hi]-path.c[lo])||1);
   return{x:a[0]+(b[0]-a[0])*t,y:a[1]+(b[1]-a[1])*t,a:Math.atan2(b[1]-a[1],b[0]-a[0])};
  }
  function curve(path,s){ // how sharp the road bends ahead (0 straight .. 1 sharp)
   var p=at(path,s),q=at(path,s+26),d=Math.abs(Math.atan2(Math.sin(q.a-p.a),Math.cos(q.a-p.a)));return Math.min(1,d/0.7);
  }
  function rev(a){return a.slice().reverse();}
  function cat(){var r=[];for(var i=0;i<arguments.length;i++){var a=arguments[i];r=r.concat(i?a.slice(1):a);}return r;}
  // ---- routes (right-hand traffic) ----
  var LANE=5.2;
  var ringPts=conv(cat(ROADS.B,ROADS.C,ROADS.Dw));
  var aPts=conv(ROADS.A),ePts=conv(ROADS.E),dePts=conv(ROADS.De);
  var routes=[
   {path:build(ringPts,-LANE),fade:true},
   {path:build(rev(ringPts),-LANE),fade:true},
   {path:build(aPts,-LANE),fade:false},
   {path:build(rev(aPts),-LANE),fade:false},
   {path:build(ePts,-LANE),fade:true},
   {path:build(rev(ePts),-LANE),fade:true},
   {path:build(dePts,-LANE),fade:true},
   {path:build(rev(dePts),-LANE),fade:true}
  ];
  // ---- cars ----
  var COLORS=['#e9eef2','#f4f4f0','#27364a','#1c1f26','#c0392b','#b9c2cc','#6b7f95','#2a6fb0','#e8b923','#8a2d2d'];
  var KINDS=[{l:17,w:8,k:'car',p:7},{l:17,w:8,k:'car',p:7},{l:19,w:8.5,k:'car',p:3},{l:24,w:9,k:'van',p:2},{l:37,w:10,k:'bus',p:1}];
  function pickKind(){var t=0,i;KINDS.forEach(function(k){t+=k.p;});var r=Math.random()*t;for(i=0;i<KINDS.length;i++){r-=KINDS[i].p;if(r<=0)return KINDS[i];}return KINDS[0];}
  function mkCar(route,s){var k=pickKind();return{route:route,s:s,v:0,vmax:34+Math.random()*16,k:k,col:COLORS[(Math.random()*COLORS.length)|0],brake:0,wait:0};}
  var cars=[];
  routes.forEach(function(r,ri){var n=Math.max(1,Math.round(r.path.len/(95+ri%2*15)*0.18));for(var i=0;i<n;i++){cars.push(mkCar(r,(i+Math.random()*0.6)*r.path.len/n));}});
  function stepCars(dt){
   routes.forEach(function(r){
    var list=cars.filter(function(c){return c.route===r;}).sort(function(a,b){return b.s-a.s;});
    for(var i=0;i<list.length;i++){
     var c=list[i],lead=list[i-1],want=c.vmax*(1-0.55*curve(r.path,c.s));
     if(lead){var gap=lead.s-lead.k.l/2-(c.s+c.k.l/2)-5;if(gap<26)want=Math.min(want,Math.max(0,lead.v*(gap/26)));if(gap<4)want=0;}
     var acc=want>c.v?26:70;c.v+=Math.max(-acc*dt,Math.min(acc*dt,want-c.v));c.s+=c.v*dt;
     if(c.s>r.path.len+20){ // back to the start, only when there is room
      var last=list[list.length-1];if(!last||last===c||last.s>60){c.s=-10;c.v=14;c.k=pickKind();c.col=COLORS[(Math.random()*COLORS.length)|0];c.vmax=34+Math.random()*16;}
      else c.s=r.path.len+20;}
    }
   });
  }
  function drawCar(c){
   if(c.s<0)return;var p=at(c.route.path,c.s),L=c.k.l,Wd=c.k.w,a=1;
   if(c.route.fade){var m=Math.min(c.s,c.route.path.len-c.s);a=Math.max(0,Math.min(1,m/24));}
   if(a<=0.02)return;
   ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.a);ctx.globalAlpha=a;
   ctx.fillStyle='rgba(0,0,0,.28)';rr(-L/2+1.5,-Wd/2+2,L,Wd,2.5);ctx.fill(); // shadow
   ctx.fillStyle=c.col;rr(-L/2,-Wd/2,L,Wd,2.5);ctx.fill();
   ctx.strokeStyle='rgba(0,0,0,.35)';ctx.lineWidth=0.6;ctx.stroke();
   if(c.k.k==='bus'){ctx.fillStyle='rgba(20,30,45,.55)';for(var i=-L/2+4;i<L/2-6;i+=6)ctx.fillRect(i,-Wd/2+1.2,4.2,Wd-2.4);}
   else{ctx.fillStyle='rgba(20,30,45,.7)';ctx.fillRect(L*0.1,-Wd/2+1.1,L*0.2,Wd-2.2);ctx.fillRect(-L*0.36,-Wd/2+1.3,L*0.12,Wd-2.6);ctx.fillStyle='rgba(255,255,255,.22)';ctx.fillRect(-L*0.2,-Wd/2+1.2,L*0.3,Wd-2.4);}
   if(night>0.3){ // lights
    ctx.globalCompositeOperation='lighter';
    var g=ctx.createRadialGradient(L/2,0,0,L/2+16,0,22);g.addColorStop(0,'rgba(255,240,190,'+0.55*night+')');g.addColorStop(1,'rgba(255,240,190,0)');ctx.fillStyle=g;ctx.fillRect(L/2-2,-16,40,32);
    ctx.fillStyle='rgba(255,70,50,'+(0.9*night)+')';ctx.fillRect(-L/2,-Wd/2+0.8,1.4,1.8);ctx.fillRect(-L/2,Wd/2-2.6,1.4,1.8);
    ctx.globalCompositeOperation='source-over';}
   ctx.restore();
  }
  function rr(x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.lineTo(x+w-r,y);ctx.quadraticCurveTo(x+w,y,x+w,y+r);ctx.lineTo(x+w,y+h-r);ctx.quadraticCurveTo(x+w,y+h,x+w-r,y+h);ctx.lineTo(x+r,y+h);ctx.quadraticCurveTo(x,y+h,x,y+h-r);ctx.lineTo(x,y+r);ctx.quadraticCurveTo(x,y,x+r,y);ctx.closePath();}
  // ---- pedestrians ----
  var CLOTHES=['#d94f3d','#2f6fb5','#f2c94c','#3a3f4a','#7b4fa3','#e9eef2','#2e8b57','#e07b39','#c14d8a','#1f2937','#9ca3af'];
  var SKIN=['#f0c9a0','#d9a577','#a9774d','#7a4e2d','#f5d5b5'];
  var HAIR=['#2b1d12','#4a3222','#8a6a3d','#1c1c1c','#c9b27c','#9a9a9a','#6b3a1e'];
  var walkPaths=WALK.map(function(w){return build(conv(w),0);});
  var peds=[],dogs=[];
  function angDiff(a,b){return Math.atan2(Math.sin(a-b),Math.cos(a-b));}
  function mkPed(pi,s,dir,kid){
   return{pi:pi,s:s,dir:dir,kid:!!kid,k:kid?0.78:(0.95+Math.random()*0.18),v:(kid?15:11)+Math.random()*7,col:CLOTHES[(Math.random()*CLOTHES.length)|0],pants:['#2a2d36','#3b4a63','#6b5b45','#1f2937'][(Math.random()*4)|0],skin:SKIN[(Math.random()*SKIN.length)|0],hair:HAIR[(Math.random()*HAIR.length)|0],bag:Math.random()<0.35,
    ph:Math.random()*6.28,pause:0,next:3+Math.random()*10,off:(Math.random()-0.5)*5,ang:null,leader:null,dog:null};
  }
  var PLAN=[[0,4],[1,2],[2,3],[3,6]];     // people per path
  PLAN.forEach(function(d){
   var P=walkPaths[d[0]];
   for(var i=0;i<d[1];i++){
    var s=Math.random()*P.len,dir=Math.random()<0.5?1:-1,a=mkPed(d[0],s,dir);peds.push(a);
    var r=Math.random();
    if(r<0.3){var b=mkPed(d[0],s,dir);b.leader=a;b.v=a.v;b.off=a.off+7;b.sideGap=1;peds.push(b);i++;}               // a couple walking side by side
    else if(r<0.42){var c=mkPed(d[0],s,dir,true);c.leader=a;c.v=a.v;c.off=a.off+6;c.sideGap=-2;peds.push(c);}          // a parent with a child
    else if(r<0.54){a.dog={wag:Math.random()*6,col:['#8a5a2b','#2b2b2b','#d9c7a0','#a0602b'][(Math.random()*4)|0]};}  // a dog walker
   }
  });
  function stepPeds(dt){
   peds.forEach(function(p){
    var P=walkPaths[p.pi];
    if(p.leader){p.dir=p.leader.dir;p.pause=p.leader.pause;p.s=p.leader.s-p.dir*p.sideGap;p.ph=p.leader.ph+(p.kid?1.3:0.6);
     var t=at(P,p.s);var want=t.a+(p.dir<0?Math.PI:0);p.ang=p.ang===null?want:p.ang+angDiff(want,p.ang)*Math.min(1,dt*6);return;}
    var t0=at(P,p.s),want0=t0.a+(p.dir<0?Math.PI:0);p.ang=p.ang===null?want0:p.ang+angDiff(want0,p.ang)*Math.min(1,dt*5);
    if(p.pause>0){p.pause-=dt;return;}
    p.next-=dt;if(p.next<=0){if(Math.random()<0.4){p.pause=2+Math.random()*5;}p.next=5+Math.random()*12;}
    var sp=p.v*(0.85+0.15*Math.sin(p.ph*0.37));p.s+=p.dir*sp*dt;p.ph+=sp*dt*0.62;
    if(p.s>P.len){p.s=P.len;p.dir=-1;p.pause=0.6;}
    if(p.s<0){p.s=0;p.dir=1;p.pause=0.6;}
   });
  }
  function drawPed(p){
   var P=walkPaths[p.pi],q=at(P,p.s),still=p.pause>0||(p.leader&&p.leader.pause>0),sw=still?0:Math.sin(p.ph),k=p.k;
   ctx.save();ctx.translate(q.x-Math.sin(q.a)*p.off,q.y+Math.cos(q.a)*p.off);ctx.rotate(p.ang===null?q.a:p.ang);ctx.scale(k,k);
   if(p.dog){ // the dog and its leash
    var d=p.dog;d.wag+=0.5;var dx=9,dy=-6.5+(still?0:Math.sin(p.ph*0.8)*0.6);
    ctx.strokeStyle='rgba(30,30,30,.7)';ctx.lineWidth=0.5;ctx.beginPath();ctx.moveTo(1,-3.4);ctx.lineTo(dx-2,dy);ctx.stroke();
    ctx.fillStyle='rgba(0,0,0,.28)';ctx.beginPath();ctx.ellipse(dx+0.8,dy+1.4,3.6,1.8,0,0,6.3);ctx.fill();
    ctx.fillStyle=d.col;ctx.beginPath();ctx.ellipse(dx,dy,3.4,1.7,0,0,6.3);ctx.fill();ctx.beginPath();ctx.arc(dx+3.3,dy,1.35,0,6.3);ctx.fill();
    ctx.strokeStyle=d.col;ctx.lineWidth=0.9;ctx.beginPath();ctx.moveTo(dx-3.2,dy);ctx.lineTo(dx-5,dy+Math.sin(d.wag)*1.2);ctx.stroke();}
   ctx.fillStyle='rgba(0,0,0,.16)';ctx.beginPath();ctx.ellipse(0.9,1.5,2.9,4.2,0,0,6.3);ctx.fill();        // shadow
   ctx.fillStyle=p.pants;ctx.beginPath();ctx.ellipse(sw*2,-1.7,1.9,1.1,0,0,6.3);ctx.fill();ctx.beginPath();ctx.ellipse(-sw*2,1.7,1.9,1.1,0,0,6.3);ctx.fill(); // legs / feet
   ctx.fillStyle=p.skin;ctx.beginPath();ctx.ellipse(-sw*1.6,-3.7,1.2,0.9,0,0,6.3);ctx.fill();ctx.beginPath();ctx.ellipse(sw*1.6,3.7,1.2,0.9,0,0,6.3);ctx.fill(); // hands
   ctx.fillStyle=p.col;ctx.beginPath();ctx.ellipse(0,0,2.5,4.1,0,0,6.3);ctx.fill();ctx.strokeStyle='rgba(0,0,0,.35)';ctx.lineWidth=0.5;ctx.stroke(); // torso
   if(p.bag){ctx.fillStyle='rgba(25,30,40,.85)';ctx.fillRect(-4.4,-2.2,2.3,4.4);}                               // backpack
   ctx.fillStyle=p.skin;ctx.beginPath();ctx.arc(0.5,0,2.1,0,6.3);ctx.fill();                                    // head
   ctx.fillStyle=p.hair;ctx.beginPath();ctx.arc(0.2,0,2.1,Math.PI*0.5,Math.PI*1.5);ctx.fill();ctx.beginPath();ctx.ellipse(-0.1,0,1.7,2.1,0,0,6.3);ctx.fill();
   ctx.restore();
  }
  // ---- light rail ----
  var railA=build(conv(RAIL),-4.2),railB=build(rev(conv(RAIL)),-4.2);
  var trams=[{path:railA,alt:railB,s:-120,v:0,wait:2},{path:railB,alt:railA,s:-120,v:0,wait:12}];
  var HID0=S([0,515])[1],HID1=S([0,605])[1];   // the tram goes under building 5 here
  var TRAM_L=92;
  function stepTrams(dt){
   trams.forEach(function(t){
    var lead=null;trams.forEach(function(o){if(o!==t&&o.path===t.path&&o.wait<=0&&o.s>t.s-5&&(!lead||o.s<lead.s))lead=o;});
    if(t.wait>0){t.wait-=dt;if(t.wait<=0&&lead&&lead.s<TRAM_L+140){t.wait=1;}return;}
    var tv=t.s<60?38:(t.path.len-t.s<160?30:46);
    if(lead){var gap=lead.s-t.s-TRAM_L-14;if(gap<90)tv=Math.min(tv,Math.max(0,lead.v*(gap/90)));if(gap<8)tv=0;}
    t.v+=(tv-t.v)*Math.min(1,dt*1.5);t.s+=t.v*dt;
    if(t.s>t.path.len+TRAM_L+10){var tp=t.path;t.path=t.alt;t.alt=tp;t.s=-TRAM_L;t.v=0;t.wait=4+Math.random()*6;}
   });
  }
  function drawTram(t){
   if(t.wait>0&&t.s<0)return;
   var n=3,seg=TRAM_L/n;
   for(var i=0;i<n;i++){
    var sc=t.s-i*(seg+1.5);if(sc<0||sc>t.path.len)continue;
    var p=at(t.path,sc);ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.a);
    var m=Math.min(sc,t.path.len-sc),hid=Math.min(1,Math.max(0,Math.min(Math.abs(p.y-HID0),Math.abs(p.y-HID1))/14)),inH=p.y>HID0&&p.y<HID1;ctx.globalAlpha=inH?0:Math.max(0,Math.min(1,m/22))*hid;
    ctx.fillStyle='rgba(0,0,0,.3)';rr(-seg/2+1.5,-4.2+2,seg,8.4,3);ctx.fill();
    ctx.fillStyle='#f3f6f9';rr(-seg/2,-4.2,seg,8.4,3);ctx.fill();ctx.strokeStyle='rgba(0,0,0,.3)';ctx.lineWidth=0.7;ctx.stroke();
    ctx.fillStyle='#1d6fd1';ctx.fillRect(-seg/2+2,-0.9,seg-4,1.8);
    ctx.fillStyle='rgba(30,45,65,.75)';ctx.fillRect(-seg/2+3,-3.2,seg-6,1.4);ctx.fillRect(-seg/2+3,1.8,seg-6,1.4);
    if(i===0){ctx.fillStyle='rgba(30,45,65,.8)';ctx.fillRect(seg/2-3.2,-3.3,2.6,6.6);}
    if(night>0.3){ctx.globalCompositeOperation='lighter';var g=ctx.createRadialGradient(seg/2,0,0,seg/2+18,0,26);g.addColorStop(0,'rgba(255,240,200,'+0.6*night+')');g.addColorStop(1,'rgba(255,240,200,0)');ctx.fillStyle=g;ctx.fillRect(seg/2-2,-18,46,36);ctx.globalCompositeOperation='source-over';}
    ctx.restore();
   }
  }
  
  return {
    step: function(dt){ night = getNight(); stepCars(dt); stepPeds(dt); stepTrams(dt); },
    draw: function(){ night = getNight(); cars.forEach(drawCar); peds.forEach(drawPed); trams.forEach(drawTram); }
  };
}
